<table>
  @if (headers && headers?.length) {
    <thead>
      <tr [ngClass]="{ sticky: stickyHeaders }">
        <ng-content select="[gbc-table-header]"></ng-content>
        <ng-content select="[gbc-table-chevron-header]"></ng-content>
        @if (clickableRows && !suppressAutoAddChevronHeader) {
          <th class="chevron-header"></th>
        }
        @if (selectableRows) {
          <th class="selectable-header"></th>
        }
      </tr>
    </thead>
  }
  <tbody>
    <ng-content></ng-content>
  </tbody>
</table>
